import React, { Component } from "react";


export default class Flags extends Component {
  render() {
    const { deal, prefix } = this.props
    return (
      <div className='flags-container'>
        {!deal.flags.includes('tcs_cancelled') && deal.flags.includes('tcs_attendee_confirmed') && <span className='toggle-flag toggle-flag-success'>{prefix && <span>{prefix}</span>}Confirmed Attendee</span>}
        {!deal.flags.includes('tcs_cancelled') && deal.flags.includes('tcs_attendee_not_confirmed')  && <span className='toggle-flag toggle-flag-warning'>{prefix && <span>{prefix}</span>}Couldnt Confirm Attendee</span>}
        {deal.flags.includes('tcs_rescheduled') && <span className='toggle-flag toggle-flag-success'>{prefix && <span>{prefix}</span>}Rescheduled</span>}
        {deal.flags.includes('tcs_presented') && <span className='toggle-flag toggle-flag-success'>{prefix && <span>{prefix}</span>}Presented</span>}
        {deal.flags.includes('tcs_not_presented') && <span className='toggle-flag toggle-flag-warning'>{prefix && <span>{prefix}</span>}Not Presented</span>}
{deal.flags.includes('on_hold') && <span className='toggle-flag toggle-flag-warning'>{prefix && <span>{prefix}</span>}On Hold</span>}
        {!prefix && deal.flags.includes('completed') && <span className='toggle-flag toggle-flag-success'>Deal Complete</span>}
        {deal.flags.includes('tcs_cancelled') && <span className='toggle-flag toggle-flag-error'>{prefix && <span>{prefix}</span>}Cancelled</span>}
      </div>
    )
  }
}
